import { render, staticRenderFns } from "./Chem51LBProject1OIQuantitativeObservations.vue?vue&type=template&id=b081ea8a&scoped=true&"
import script from "./Chem51LBProject1OIQuantitativeObservations.vue?vue&type=script&lang=ts&"
export * from "./Chem51LBProject1OIQuantitativeObservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b081ea8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VContainer,VFileInput,VForm,VRow,VTextField})
